import React, { useState, useEffect } from 'react';
import { apiConfig, mockApi } from '../utils/apiConfig';

const MockDataToggle = () => {
  const [useMockData, setUseMockData] = useState(false);
  const [stats, setStats] = useState(null);
  const [isRegenerating, setIsRegenerating] = useState(false);

  useEffect(() => {
    // Load initial setting
    setUseMockData(apiConfig.isUsingMockData());
    
    // Load stats if in mock mode
    if (apiConfig.isUsingMockData()) {
      loadStats();
    }
  }, []);

  const loadStats = async () => {
    try {
      const response = await mockApi.getStats();
      setStats(response.data.data);
    } catch (error) {
      console.error('Error loading mock stats:', error);
    }
  };

  const handleToggle = (enabled) => {
    setUseMockData(enabled);
    apiConfig.setUseMockData(enabled);
    
    // Load stats when switching to mock mode
    if (enabled) {
      loadStats();
    } else {
      setStats(null);
    }
    
    // Trigger page refresh to update all components
    window.location.reload();
  };

  const handleRegenerate = async () => {
    if (!useMockData) return;
    
    setIsRegenerating(true);
    try {
      await mockApi.regenerateData();
      await loadStats();
      alert('モックデータを再生成しました！');
    } catch (error) {
      console.error('Error regenerating mock data:', error);
      alert('モックデータの再生成に失敗しました。');
    } finally {
      setIsRegenerating(false);
    }
  };

  // Only show in development environment
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-white shadow-lg rounded-lg p-4 border border-gray-200 max-w-sm">
      <div className="text-sm font-medium text-gray-700 mb-3">
        🛠️ 開発者ツール
      </div>
      
      {/* Mock Data Toggle */}
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm text-gray-600">
          {useMockData ? '🧪 仮データ表示中' : '📊 本番データ表示中'}
        </label>
        <button
          onClick={() => handleToggle(!useMockData)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
            useMockData ? 'bg-indigo-600' : 'bg-gray-200'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              useMockData ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
      
      {/* Mock Data Stats */}
      {useMockData && stats && (
        <div className="text-xs text-gray-500 mb-3">
          <div>女優: {stats.actresses.total}名</div>
          <div>作品: {stats.videos.total}本</div>
          <div>メーカー: {stats.videos.makers}社</div>
        </div>
      )}
      
      {/* Regenerate Button */}
      {useMockData && (
        <button
          onClick={handleRegenerate}
          disabled={isRegenerating}
          className="w-full text-xs bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 text-gray-700 py-2 px-3 rounded border transition-colors"
        >
          {isRegenerating ? '再生成中...' : '🔄 データ再生成'}
        </button>
      )}
      
      {/* Mock Data Indicator */}
      {useMockData && (
        <div className="mt-2 text-xs text-orange-600 font-medium">
          ⚠️ 現在は仮データを表示中です
        </div>
      )}
    </div>
  );
};

export default MockDataToggle;